import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {EmailFieldVI, TextFieldVI} from '../../TextFieldVI';
import {InputType} from '../../../configuration/inputTypes/inputTypes.config';
import React from 'react';
import {InputsBox} from '../Style/AutoProjectMetaData.style';
import useProjectMetaData from '../Controller/AutoProjectMetaData.controller';
import {IPropsView} from '../Config/AutoProjectMetaData.types';

const AutoProjectMetaDataView = ({autoProjectState, setState, initialNewAutoProject}: IPropsView) => {
    const {handleOnBlurProjectName} = useProjectMetaData(autoProjectState, initialNewAutoProject);

    return (
        <InputsBox>
            <TextFieldVI helperTextValue={autoProjectState.showProjectNameError ? _SYSTEM_TITLES.autoProjectMandatoryNameAlert : ''}
                globalError={autoProjectState.nameExistError} initValue={autoProjectState.projectNameInit} getValue={(value) => setState({projectName: value, showProjectNameError: false})} inputType={InputType.ProjectName} inputLabel={_SYSTEM_TITLES.autoProjectNameLabel} onBlurFunc={handleOnBlurProjectName}/>

            <EmailFieldVI getValue={(value) => setState({emails: value})} inputLabel={_SYSTEM_TITLES.autoProjectEmailLabel}/>

            <TextFieldVI initValue={autoProjectState.projectDescriptionInit} getValue={(value) => setState({projectDescription: value})} inputType={InputType.ProjectDescription} inputLabel={_SYSTEM_TITLES.autoProjectDescriptionLabel} rows={3}/>
        </InputsBox>
    );


};

export default AutoProjectMetaDataView;
